module.exports = __webpack_public_path__ + "static/media/qatar.04286a5b.jpg";